export const COLORS = { 
    green: "#1E9F1B",
    orange: "#FF9C20",
    crimson: "#FF2D20",
    blue: "#2E1B9F",
    darkBlue: "#60227D",
    grey: "#A9A6A6",
    white: "#fff"
}